var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _vm.loading
              ? _c("Loading")
              : [
                  _vm.potentialDates.length === 0
                    ? _c("div", [
                        _vm._v("Es sind derzeit keine Termine vorhanden.")
                      ])
                    : [
                        _c("Calendar", {
                          attrs: {
                            "is-expanded": "",
                            attributes: _vm.calendarAttributes
                          },
                          on: { dayclick: _vm.onDayClick },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "day-content",
                                fn: function(ref) {
                                  var day = ref.day
                                  var attributes = ref.attributes
                                  return [
                                    _c(
                                      "a",
                                      {
                                        class: {
                                          "vc-day-content-custom": true,
                                          "vc-day-content-custom--in-month":
                                            day.inMonth,
                                          "vc-day-content-custom--selected": _vm.isSelected(
                                            day
                                          )
                                        },
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.onDayClick(day)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(day.label) +
                                            "\n\t\t\t\t\t\t\t"
                                        ),
                                        _vm.getDatesCount(day) > 0
                                          ? _c(
                                              "span",
                                              { staticClass: "count-bubble" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.getDatesCount(day))
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1503321140
                          )
                        }),
                        _vm._v(" "),
                        _vm.selectedDate
                          ? _c("div", [
                              _vm.datePotentialDates.length === 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mt-4 font-weight-extra-bold"
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\tKeine Termine vorhanden am " +
                                          _vm._s(
                                            _vm._f("date")(_vm.selectedDate)
                                          ) +
                                          ".\n\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "communication-appointment-fan--appointments"
                                    },
                                    _vm._l(_vm.datePotentialDates, function(
                                      potentialDate
                                    ) {
                                      return _c("PotentialDate", {
                                        key: potentialDate.id,
                                        attrs: {
                                          "potential-date": potentialDate,
                                          "list-type": _vm.listType
                                        },
                                        on: { change: _vm.loadPotentialDates }
                                      })
                                    }),
                                    1
                                  )
                            ])
                          : _vm._e()
                      ]
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c("footer")
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h1", [_vm._v("Termine")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }